module.exports = __webpack_public_path__ + "static/img/zhihui1.2afc46aa.png";